module.exports = "/_next/static/images/rice-e502b9d7cb9d106065fce4690c77d88d.jpg";